<ng-template #loadingGeneral>
  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>
</ng-template>

<ng-container *ngIf="!loading else loadingGeneral">
  <mat-card appearance="outlined" fxLayout="column">
    <mat-card-header>
      <mat-card-title>{{box?.identifier}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-list>
        <mat-list-item>
          <p>
            <strong>Enabled</strong>
            {{box?.enabled}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Created by:</strong>
            {{box?.createdBy?.firstName}} {{box?.createdBy?.lastName}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Hardware Version:</strong>
            {{box?.hardwareVersion}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Identifier:</strong>
            {{box?.identifier}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Software Version:</strong>
            {{box?.softwareVersion}}
          </p>
        </mat-list-item>
        <mat-list-item>
          <p>
            <strong>Status:</strong>
            {{box?.status! | splitCamelCase}}
          </p>
        </mat-list-item>
        <ng-container *ngIf="authService.loggedUser().permissions | hasPermission: 'researcher'">
          <mat-list-item>
            <p>
              <strong>Testbed</strong>
              {{box?.currentTestbedIdentifier}}
            </p>
          </mat-list-item>
        </ng-container>
      </mat-list>

      <mat-dialog-actions fxLayoutAlign="end" fxLayoutGap="3%">

        <!--EDIT-->
        <button *awIsInAnyRole="['admin', 'logistic']" mat-button color="primary" [disabled]="disabled"
          (click)="openEditDialog()">
          <mat-icon>
            edit
          </mat-icon>
          Edit
        </button>

        <!--ENABLE-->
        <ng-container *awIsInAnyRole="['admin']">
          <button mat-button (click)="performAction(true)" *ngIf="!box?.enabled" [disabled]="disabled">
            <mat-icon>settings_power</mat-icon>
            Enable box
          </button>
        </ng-container>

        <!--DISABLE-->
        <ng-container *awIsInAnyRole="['admin']">
          <button mat-button (click)="performAction( true)" *ngIf="box?.enabled" [disabled]="disabled">
            <mat-icon color="primary">settings_power</mat-icon>
            Disable box
          </button>
        </ng-container>

        <!--STATUS-->
        <ng-container *awIsInRoleAndStatusForThisEntity="[
                  {permission: 'admin', status: boxStatus.new, entity: box},
                  {permission: 'logistic', status: boxStatus.new, entity: box},
                  {permission: 'admin', status: boxStatus.onTheShelf, entity: box},
                  {permission: 'logistic', status: boxStatus.onTheShelf, entity: box},
                  {permission: 'admin', status: boxStatus.broken, entity: box},
                  {permission: 'logistic', status: boxStatus.broken, entity: box},
                  {permission: 'admin', status: boxStatus.toBeConfigured, entity: box},
                  {permission: 'logistic', status: boxStatus.toBeConfigured, entity: box},
                  {permission: 'admin', status: boxStatus.assigned, entity: box},
                  {permission: 'logistic', status: boxStatus.assigned, entity: box},
                  {permission: 'admin', status: boxStatus.shipped, entity: box},
                  {permission: 'customer', status: boxStatus.shipped, entity: box},
                  {permission: 'admin', status: boxStatus.delivered, entity: box},
                  {permission: 'customer', status: boxStatus.delivered, entity: box},
                  {permission: 'admin', status: boxStatus.mounted, entity: box},
                  {permission: 'customer', status: boxStatus.mounted, entity: box},
                  {permission: 'admin', status: boxStatus.available, entity: box},
                  {permission: 'customer', status: boxStatus.available, entity: box},
                  {permission: 'admin', status: boxStatus.unavailable, entity: box},
                  {permission: 'customer', status: boxStatus.unavailable, entity: box},
                  {permission: 'admin', status: boxStatus.inUse, entity: box},
                  {permission: 'customer', status: boxStatus.inUse, entity: box},
                  {permission: 'admin', status: boxStatus.updating, entity: box},
                  {permission: 'customer', status: boxStatus.updating, entity: box},
                  {permission: 'admin', status: boxStatus.fail, entity: box},
                  {permission: 'customer', status: boxStatus.fail, entity: box},
                  {permission: 'admin', status: boxStatus.toShipBack, entity: box},
                  {permission: 'customer', status: boxStatus.toShipBack, entity: box},
                  {permission: 'admin', status: boxStatus.goingHome, entity: box},
                  {permission: 'logistic', status: boxStatus.goingHome, entity: box},
                ]">
          <!--Se la box non è mounted e il contratto NON è boxesWaiting, mostra -->
          <button
            *ngIf="(box?.status !== boxStatus.mounted) || (box?.status === boxStatus.mounted && (box?.contract?.status === contractStatus.ongoing || box?.contract?.status === contractStatus.extended))"
            mat-button [disabled]="disabled" (click)="performAction(false)">
            <mat-icon color="primary">
              new_releases
            </mat-icon>
            Manage
          </button>
        </ng-container>

        <!--DELETE-->
        <button *awIsInRoleAndStatusForThisEntity="[
                          {permission: 'admin', status: boxStatus.onTheShelf, entity: box},
                          {permission: 'admin', status: boxStatus.toBeConfigured, entity: box},
                          {permission: 'admin', status: boxStatus.broken, entity: box}
                        ]" [disabled]="disabled" (click)="deleteBox()" mat-button>
          <mat-icon>
            delete
          </mat-icon>
          Delete box
        </button>

      </mat-dialog-actions>

    </mat-card-content>
  </mat-card>
</ng-container>
